import { OnboardingType } from '@/modules/account/types';
import { makeAutoObservable } from 'mobx';

export class PageStore {
  isOnboardingShown: Record<OnboardingType, boolean> = {
    polls: false,
    opinions: false,
    tournaments: false,
    general: false,
  };

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setIsOnboardingShown(type: OnboardingType, value = true) {
    this.isOnboardingShown[type] = value;
  }
}
